/**
 * ``/workspace/reports/$reportId`` — Voice of X report detail page.
 *
 * Thin route file (DRY pattern matching
 * ``workspace/projects/$projectId.tsx``): heavy lifting lives in
 * ``features/voice_report/components/VoiceReportDetailPage.tsx`` so the
 * route stays a trivial pass-through. The tabbed surface + lazy tab
 * panels + report query all live in that component.
 *
 * No loader is wired: ``useVoiceReport`` is a TanStack Query call with
 * cache, so a SPA navigation from the hub list opens with the cached
 * row immediately and only blocks on the first ever visit. Adding a
 * route-level loader would duplicate that cache for no observable win.
 */

import { createFileRoute, useNavigate } from "@tanstack/react-router";
import * as React from "react";

import { VoiceReportDetailPage } from "@/features/voice_report";

export const Route = createFileRoute("/_authed/workspace/reports/$reportId")({
  component: VoiceReportDetailRoute,
});

function VoiceReportDetailRoute(): React.ReactElement {
  const { reportId } = Route.useParams();
  const navigate = useNavigate();
  const handleBack = React.useCallback(() => {
    void navigate({ to: "/workspace/reports" });
  }, [navigate]);
  return <VoiceReportDetailPage reportId={reportId} onBack={handleBack} />;
}
